import { FaEnvelope, FaGraduationCap, FaUniversity, FaUserGraduate } from "react-icons/fa";
import "./StudentProfile.css";

function StudentProfile({ student }) {
  const profileDetails = [
    { label: "Email", value: student?.email || "Not available", icon: <FaEnvelope /> },
    { label: "Stream", value: student?.stream || "Not available", icon: <FaGraduationCap /> },
    { label: "College", value: student?.college || "Not available", icon: <FaUniversity /> },
    { label: "Year", value: student?.year || "Not available", icon: <FaUserGraduate /> },
  ];
  const initials = (student?.fullname || "Student")
    .split(" ")
    .map((name) => name[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <section id="student-profile" className="student-page-profile-section" data-aos="fade-up" data-aos-duration="700">
      <div className="student-page-profile-card" data-aos="fade-left" data-aos-delay="80" data-aos-duration="650">
        <div className="student-page-profile-heading">
          <div className="student-page-profile-avatar">{initials}</div>
          <div>
            <p className="student-page-profile-label">Student Profile</p>
            <h2>{student?.fullname || "Student"}</h2>
            <span className="student-page-profile-status">
              {student?.instituteStatus || "Currently studying at this institute"}
            </span>
          </div>
        </div>

        <div className="student-page-profile-details" data-aos="fade-up" data-aos-delay="120" data-aos-duration="650">
          {profileDetails.map((detail) => (
            <div className="student-page-profile-detail" key={detail.label}>
              <span className="student-page-profile-detail-icon">{detail.icon}</span>
              <div>
                <p>{detail.label}</p>
                <h3>{detail.value}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StudentProfile;
